import React, { useEffect, useRef } from "react";
import { Trigger } from "./trigger";
import { Content } from "./content";
import { useElementClickListener } from "../../../../hooks/use-element-click-listener";
// import { useElementClickListener } from "../../../hooks/use-element-click-listener";

/**
 * Componente que representa el contenedor de un componente que se expanded y contrae, ej: combobox, select, dropdown, etc.
 * @param {Object} props - Propiedades del componente `Container`.
 * @param {boolean} props.expanded - Indica si el contenedor está expandido o colapsado.
 * @param {function} props.setExpanded - Función para establecer el estado de expansión del contenedor.
 * @param {ReactNode} props.children - Elementos secundarios renderizados dentro del contenedor.
 * @param {number} props.zIndex - Valor del índice de apilamiento (z-index) del contenedor.
 * @param {string} props.maxWidth - Ancho máximo del contenedor.
 * @returns {JSX.Element} Elemento JSX que representa el componente `Container`.
 */
export const Container = ({ expanded, setExpanded, children, zIndex, maxWidth }) => {
	const childrenElements = React.Children.toArray(children);
	const trigger = childrenElements.find((child) => child?.type === Trigger);
	const content = childrenElements.find((child) => child?.type === Content);
	const ref = useRef(null);
	const lastActiveElementRef = useRef(null);
	const clickListener = useElementClickListener({ ref });

	useEffect(() => {
		if (clickListener.clickedOutside) {
			setExpanded && setExpanded(false);
		}
	}, [clickListener?.clickedOutside]);

	useEffect(()=>{

		if(expanded === false) return;
		const handleEsc = (e)=>{
			lastActiveElementRef.current = document.activeElement;
			if(e.key === "Escape"){
				setExpanded && setExpanded(false);
				if(lastActiveElementRef.current){
					lastActiveElementRef.current.focus();
				}
			}
		}
		document.addEventListener('keydown', handleEsc);
		return ()=>{
			document.removeEventListener('keydown', handleEsc);
		}

	},[expanded, setExpanded])

	return (
		<div
			ref={ref}
			className={`base-select ${expanded ? "expanded" : "collapsed"}`}
			style={{ zIndex: zIndex || 1, maxWidth: maxWidth ? maxWidth : "100%" }}
		>
			{trigger}
			{content}
		</div>
	);
};
